export default __webpack_public_path__ + "media/images/btn_report-98f0508b.png";